<template>
    <div class="bubly-pride">
        <div class="bubly-pride__left">
            <p>we’re partnering with the<br/>
                Stonewall Inn Gives Back Initiative<br/>
                to celebrate <span class="red">L</span><span class="orange">G</span><span class="yellow">B</span><span class="green">T</span><span class="blue">Q</span><span class="purple">+</span>&nbsp;<span class="red">c</span><span class="orange">h</span><span class="yellow">o</span><span class="green">s</span><span class="blue">e</span><span class="purple">n</span>&nbsp;<span class="pink">f</span><span class="cyan">a</span><span class="brown">m</span><span class="red">i</span><span class="orange">l</span><span class="yellow">i</span><span class="green">e</span><span class="blue">s</span><br/>
                and the safe spaces where they form<br/>
                and&nbsp;flourish.<br/>
            </p>
            <router-link to="pride">
                <button class="pride-btn">learn more</button>
           </router-link>
        </div>
        <div class="bubly-pride__right">
            <img src="../assets/pride_homepage/BublyLogo@3x.png"/>
            <img src="../assets/pride_homepage/StonewallInnGivesBackInitiative@3x.png"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "pride"
    }
</script>


<style lang='scss' scoped>
.bubly-pride {
    background-image: url(./../assets/pride_homepage/MobileBG@3x.png);
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 30px;
    height: 195vw;


    @media(min-width: 390px) {
        height: 91vh;
    }

    @media only screen and (min-width: 768px) and (max-width: 950px)  {
        padding: 0px 50px;
        height: 120.2vw;
        background-size: contain;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        background-image: url(./../assets/pride_homepage/TabletBG@3x.png);
    }

    @media(min-width: 950px) {
        padding: 0 75px;
        height: 50vw;
        justify-content: space-between;
        flex-direction: row;
        background-image: url(./../assets/pride_homepage/DesktopBG@3x.png);
    }

    @media only screen and (min-width: 950px) and (max-width: 1050px)  {
        padding: 40px 30px;
    }

    @media(min-width: 2560px) {
        height: 38vw;
        padding: 0 400px;
        background-position: center center;
    }

    &__left {
        text-align: left;

        @media(max-width: 768px) {
            order: 1;
            text-align: center;
        }

        @media only screen and (min-width: 768px) and (max-width: 950px)  {
            text-align: left;
            order: 1;
        }

        @media(min-width: 950px) {
            flex: 0 0 50%;
        }

        p {

            font-size: 25px;
            line-height: 34px;

            @media(max-width: 768px) {
                br {
                    display: none;
                }
            }

            @media only screen and (min-width: 768px) and (max-width: 950px)  {
                text-align: left;
            }

            @media only screen and (min-width: 950px) and (max-width: 1050px)  {
                font-size: 20px;
                line-height: 25px;
            }


            @media(min-width: 1700px) {
                font-size: 38px;
                line-height: 52px;
            }

        }
    }

    &__right {
        display: flex;
        flex-direction: row;
        align-items: center;

        img {
            &:nth-of-type(1) {
                width: 116px;
                margin-right: 10px;
                @media(min-width: 1700px) {
                    width: 168px;
                    margin-right: 40px;
                }
            }
            &:nth-of-type(2) {
                width: 192px;
                @media(min-width: 1700px) {
                    width: 286px;
                }
            }
        }
    }

    .pride-btn {
        border-radius: 22.5px;
        font-family: 'Ginger', Helvetica, Arial, sans-serif;
        background-color: #009fdf;
        border: 0;
        font-size: 26px;
        font-weight: 600;
        color: #ffffff;
        padding: .2em 1em;
        cursor: pointer;
        line-height: 39px;
        height: 45px;

        &:hover {
            background-color: #ffffff;
            color: #009fdf;
        }
        
    }

    img{
        width: 100%;
    }


    .red {
        color: #eb1c24;
    }

    .orange {
        color: #f68c1e;
    }

    .yellow {
        color: #fae72b;
    }

    .green {
        color: #16b036;
    }

    .blue {
        color: #3e62b0;
    }

    .purple {
        color: #6d459b;
    }

    .pink {
        color:#f775cd;
    }

    .cyan {
        color: #02b9db;
    }

    .brown {
        color: #8d5e3b;
    }

} 

</style>


// WEBPACK FOOTER //
// src/components/Pride.vue